export type ActionErrorPayload = {
  status?: boolean
  success?: boolean
  formError?: string
  error?: string
  sfError?: string | { error?: string }
  errors?: { fieldErrors?: Record<string, unknown> }
}

export function getActionErrorPayload(data: unknown): ActionErrorPayload | null {
  if (!data || typeof data !== 'object') {
    return null
  }

  const record = data as ActionErrorPayload & { success?: boolean }
  const formError =
    typeof record.formError === 'string' && record.formError.trim() ? record.formError.trim() : ''
  const error = typeof record.error === 'string' && record.error.trim() ? record.error.trim() : ''
  const sfError =
    typeof record.sfError === 'string'
      ? record.sfError.trim()
      : typeof record.sfError?.error === 'string'
      ? record.sfError.error.trim()
      : ''

  const formFieldError =
    Array.isArray(record.errors?.fieldErrors?._form) &&
    typeof record.errors?.fieldErrors?._form?.[0] === 'string'
      ? record.errors.fieldErrors._form[0].trim()
      : typeof record.errors?.fieldErrors?._form === 'string'
      ? record.errors.fieldErrors._form.trim()
      : ''

  const message = formError || error || sfError || formFieldError

  if (!message) {
    return null
  }

  if (record.status === false || record.success === false) {
    return { status: false, formError: message, error: message }
  }

  return { status: false, formError: message, error: message }
}
